import type { HostCapabilities } from "../../capabilities";
import type { MarlinStoreDb } from "../infra/db";
import * as screens from "./store";
import { warn } from "../infra/effects";

export const initializeScreens = async (
  db: MarlinStoreDb,
  capabilities: Pick<HostCapabilities, "screens">,
  screenId: number,
) => {
  const displays = await capabilities.screens.displays();
  if (displays.length > 0) await screens.setScreens(db, displays);
  else
    await db.transaction("rw", db.screens, async () => {
      if (!(await db.screens.get(screenId)))
        await db.screens.add(screens.defaultScreen(screenId));
    });
};

export const createScreensHost = (
  db: MarlinStoreDb,
  capabilities: Pick<HostCapabilities, "screens" | "windows">,
  screenId: number,
) => {
  const { windows } = capabilities;
  return {
    saveScreenConfiguration: async () =>
      screens.saveScreenConfiguration(
        db,
        (await windows?.connectedScreenIds()) ?? [screenId],
      ),
    resetScreenConfiguration: async () => {
      const all = await screens.resetScreenConfiguration(
        db,
        await capabilities.screens.displays(),
      );
      const open = new Set((await windows?.connectedScreenIds()) ?? [screenId]);
      const missing = all
        .filter((s) => s.isShowing && !open.has(s.id))
        .map((s) => s.id);
      const created =
        windows && missing.length > 0 ? await windows.open(missing) : 0;
      await windows?.focus(missing[0] ?? screenId).catch(warn("focus"));
      return {
        success: true as const,
        resetScreens: all,
        createdWindows: created,
      };
    },
  };
};
